import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function useDashboardSummary(days = 7) {
  return useQuery({
    queryKey: ["dashboard", "summary", days],
    queryFn: () => api.dashboardSummary(days),
    staleTime: 60_000,
  });
}

export function useProjectAnalytics(projectId: number | null, days = 30) {
  return useQuery({
    queryKey: ["dashboard", "project-analytics", projectId, days],
    queryFn: () => api.projectAnalytics(projectId!, days),
    enabled: projectId != null && Number.isFinite(projectId),
    staleTime: 60_000,
  });
}

export function useUnreadMentions(limit = 5) {
  return useQuery({
    queryKey: ["unread-mentions", limit],
    queryFn: () => api.unreadMentions(limit),
    staleTime: 30_000,
  });
}

export function useUsage() {
  return useQuery({
    queryKey: ["usage"],
    queryFn: () => api.getUsage(),
    staleTime: 60_000,
  });
}
